import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export type AssessmentQuestionNavProps = {
  questionIndex: number;
  totalQuestions: number;
  onPrevious: () => void;
  onNext: () => void;
  nextLabel?: string;
};

export function AssessmentQuestionNav({
  questionIndex,
  totalQuestions,
  onPrevious,
  onNext,
  nextLabel = 'Next',
}: AssessmentQuestionNavProps) {
  const showPrevious = questionIndex > 0;

  return (
    <div className="asses-assessment-nav asses-frame-parent15">
      <div className="asses-assessment-nav__start">
        {showPrevious ? (
          <button
            type="button"
            className="app-btn app-btn--secondary app-btn--sm asses-assessment-nav__btn"
            onClick={onPrevious}
          >
            <ChevronLeft size={18} strokeWidth={2.25} aria-hidden />
            Previous
          </button>
        ) : null}
      </div>
      <p className="asses-assessment-nav__meta asses-next1">
        Question {questionIndex + 1} of {totalQuestions}
      </p>
      <button
        type="button"
        className="app-btn app-btn--primary app-btn--sm asses-assessment-nav__btn"
        onClick={onNext}
      >
        {nextLabel}
        <ChevronRight size={18} strokeWidth={2.25} aria-hidden />
      </button>
    </div>
  );
}

export default AssessmentQuestionNav;
